<template>
  <div class="score">
    <span class="score-title">{{ category }}</span>
    <span class="star full-star" v-for="count in rating" :key="count + '-1'">★</span>
    <span class="star empty-star" v-for="count in 5 - rating" :key="count + '-2'">☆</span>
  </div>
</template>

<script>
export default {
  name: "Rate",
  props: ["category", "rating"],
}
</script>
<style lang="scss" scoped>
.score {
  margin-bottom: 5px;
  .score-title {
    font-size: 0.9rem;
    width: 70px;
    display: inline-block;
  }
  .star {
    font-size: 20px;
  }
  .full-star {
    color: orange;
  }
  .empty-star {
    color: #dedede;
  }
}
</style>
